import axios from "axios";
import { store } from "../../store";

export async function createTicketTypeAction() {
  const token =
    sessionStorage.getItem("token") ?? localStorage.getItem("token");
  const {
    name,
    ticketInfomationDescription,
    ticketInfomationTitle,
    price,
    unit,
    currency,
  } = store.getState().ticketType;

  const { id } = store.getState().ticket;
  const dataToSend = {
    ticketId: id,
    name,
    ticketPrice: {
      price: parseInt(price.toString()),
      currency,
      unit,
    },
    ticketInformation:
      ticketInfomationDescription && ticketInfomationTitle
        ? {
            title: ticketInfomationTitle,
            description: ticketInfomationDescription,
          }
        : null,
  };

  return await axios
    .post(
      `${process.env.REACT_APP_API_ORIGIN}/1.0.0/cms/tickets/ticket-type`,
      dataToSend,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    )
    .then((res) => res.data);
}
